import colors from "core/resources/theme/colors";
import styled from "styled-components";

export const FieldContainer = styled.div<any>`
  width: 100%;
  .chakra-input {
    font-size: ${(props: any) => props.fontSize}px !important;
    border: 1px solid #e2e8f0;
    padding: 10px 16px;
    border-radius: 6px;
    width: 100%;
    outline-color: ${colors.primary};
  }
  .chakra-input:hover,
  .chakra-input:focus {
    border-color: ${(props: any) =>
      props.isInvalid ? colors.red : colors.primary} !important;
    box-shadow: 0 0 0 1px
      ${(props) => (props.isInvalid ? colors.red : colors.primary)} !important;
    transition: all 0.2s;
  }
`;
